/**
 * Account-bound auth failures live outside the dynamically imported Firebase implementation so eager
 * callers can recognise them without pulling the Firebase SDK into the initial bundle.
 */

/** Raised when a legal-record request can no longer prove the exact Firebase account it belongs to. */
export class FirebaseIdentityChangedError extends Error {
	static readonly ERROR_NAME = "FirebaseIdentityChangedError";

	constructor() {
		super("Firebase identity changed during account-bound request");
		this.name = FirebaseIdentityChangedError.ERROR_NAME;
	}
}

/** Matches across the auth facade's dynamic-import boundary without relying on `instanceof`. */
export function firebaseIdentityChanged(error: unknown): boolean {
	return error instanceof Error && error.name === FirebaseIdentityChangedError.ERROR_NAME;
}
